import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface WaitDialogInput {
  close: Promise<void>;
  message?: string;
}

export type WaitDialogResult = undefined;

@Component({
  selector: 'app-wait-dialog',
  templateUrl: './wait-dialog.component.html',
  styleUrls: ['./wait-dialog.component.scss'],
  standalone: false,
})
export class WaitDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) protected readonly data: WaitDialogInput,
    dialogRef: MatDialogRef<WaitDialogComponent, WaitDialogResult>,
  ) {
    data.close.then(() => dialogRef.close());
  }
}
